<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 质检客服数据 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <FilterCommon :model="filterModel" :isReset="true" @search="search" @reset="reset">
          <template v-slot:button>
            <el-button type="primary" @click="isCompare = !isCompare">{{ isCompare ? '取消对比' : '设置对比' }}</el-button>
          </template>
        </FilterCommon>
        <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
          <el-table-column prop="date" label="时间区间" width="250" />
          <el-table-column prop="name" label="质检客服" width="150" />
          <el-table-column prop="normal_number" label="累计普客质检量" width="150" sortable />
          <el-table-column prop="vip_number" label="累计VIP质检量" width="150" sortable />
          <el-table-column prop="worksn_number" label="累计工单质检量" width="150" sortable />
          <el-table-column prop="total_number" label="累计质检量总量" width="150" sortable />
          <el-table-column prop="success_count" label="申诉成功量" width="150" sortable />
          <el-table-column prop="correct_rate" label="准确率" width="150" sortable />
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="page" :limit.sync="limit" @pagination="handlePagination" />
      </div>
    </div>
  </div>
</template>

<script>
import { getQualifyDataApi } from '@/api/work_data.js';
import { getAdminCheckList } from '@/api/ordinary_report.js';
import Pagination from '@/components/pagination/index';
import FilterCommon from '@/components/common/Filter';
import dayjs from 'dayjs';

export default {
  components: { Pagination, FilterCommon },
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      tableData: [],
      adminList: [],
      isCompare: false, // 是否设置对比
      defaultDate: dayjs(new Date(new Date())).format('YYYY-MM-DD'),
      searchParams: {
        page: 1,
        limit: 10,
        start_date: dayjs(new Date(new Date())).format('YYYY-MM-DD'),
        end_date: dayjs(new Date(new Date())).format('YYYY-MM-DD'),
      },
    };
  },
  computed: {
    filterModel() {
      let model = [
        {
          span: 6,
          type: 'date-picker',
          label: '时间区间：',
          key: 'date',
          dateType: false,
          empty: false,
          showDefault: true,
        },
        {
          type: 'select',
          label: '质检客服：',
          key: 'admin_id',
          span: 4,
          isMultiple: true,
          options: this.adminList,
        },
      ];
      let compareModel = [
        {
          span: 6,
          type: 'date-picker',
          label: '时间区间：',
          key: 'date',
          dateType: false,
          empty: false,
          showDefault: true,
        },
        {
          type: 'select',
          label: '质检客服：',
          key: 'admin_id',
          span: 4,
          isMultiple: true,
          options: this.adminList,
        },
        {
          span: 6,
          type: 'date-picker',
          label: '时间区间：',
          key: 'compareDate',
          dateType: false,
          empty: false,
          showDefault: true,
        },
        {
          type: 'select',
          label: '质检客服：',
          key: 'admin_id_compare',
          span: 4,
          isMultiple: true,
          options: this.adminList,
        },
      ];
      return this.isCompare ? compareModel : model;
    },
  },
  created() {
    this.getTableList();
    this.getUserList();
  },
  methods: {
    // 获取table列表
    async getTableList() {
      const r = await getQualifyDataApi(this.searchParams);
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.tableData = r.data.data.data;
      this.total = r.data.data.total;
    },
    // 获取质检客服列表
    async getUserList() {
      const r = await getAdminCheckList();
      this.adminList = [...r.data.data];
    },
    // 搜索
    search(e) {
      let obj = {
        page: this.searchParams.page,
        limit: this.searchParams.limit,
        start_date: (e.date && e.date[0]) || this.defaultDate,
        end_date: (e.date && e.date[1]) || this.defaultDate,
        admin_id: e.admin_id,
      };
      this.searchParams = this.isCompare
        ? {
            ...obj,
            is_compare: 1,
            start_date_compare: (e.compareDate && e.compareDate[0]) || this.defaultDate,
            end_date_compare: (e.compareDate && e.compareDate[1]) || this.defaultDate,
            admin_id_compare: e.admin_id_compare,
          }
        : obj;
      this.getTableList();
    },
    // 重置
    reset() {
      this.searchParams = {
        page: 1,
        limit: 10,
        start_date: this.defaultDate,
        end_date: this.defaultDate,
      };
      this.isCompare = false;
      this.getTableList();
    },
    // 处理翻页
    handlePagination(obj) {
      this.searchParams = Object.assign(this.searchParams, {
        page: obj.page,
        limit: obj.limit,
      });
      this.getTableList();
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: rgb(248, 229, 229);
}
</style>
